import { serializeChildren } from '#pplx/frontend/composer-sdk/internal/serialization/serializeChildren.js';
/**
 * Serializes saved editor state to Markdown without creating a live editor.
 *
 * @example
 * const markdown = serializedStateToMarkdown(savedState);
 * // => 'Read [the docs](https://example.com/docs)'
 */
export function serializedStateToMarkdown(state) {
    return serializeChildren({ children: state.root.children, separator: '\n' });
}
//# sourceMappingURL=serializedStateToMarkdown.js.map